import { IconChevronRight } from "@tvg/fuse/icon/all";
import { Link } from "@tvg/fuse/link";
import { backgroundConfig } from "client/components/TextBlock/config";
import React from "react";

const richTextEditorStandaloneLink = (
  matchValue: string,
  {
    background,
    renderToString,
  }: { background?: string; renderToString: NonNullable<typeof globalThis.__renderToString> },
) => {
  const linkAttributes = {
    href: matchValue.split('href="').pop()?.split('"')[0],
    text: matchValue.split('">').pop()?.split("</a>")[0],
    title: matchValue.match('title="') ? matchValue.split('title="').pop()?.split('"')[0] : undefined,
  };

  const isCentreAligned = matchValue.match("fuse-text-block--center-align");

  return renderToString(
    <Link
      href={linkAttributes.href}
      icon={<IconChevronRight />}
      iconRight
      centreAlign={isCentreAligned ? true : false}
      title={linkAttributes.title}
      white={background && backgroundConfig[background].darkContrast ? true : false}
      standalone
    >
      {linkAttributes.text}
    </Link>,
  );
};

export default richTextEditorStandaloneLink;
